import { Link } from "gatsby"
import React, { useEffect, useState } from "react"
import { useStaticQuery, graphql } from "gatsby"
import ModalTiny from "react-bootstrap/Modal"
import cardImg from "../../images/id-img.png"
import teamstatic from "../../images/arabian-avathar.jpg"
import { ListPropertyBaseURL } from "../../common/site/utils"
import BookViewForm from "../forms/book-a-viewing-form"

import { SiteName } from "../../common/site/utils"
import "./ContactDetails.scss"
import { PeopleEmail } from "../../common/queries/common_use_query"
import ImageTransform from "../../common/ggfx-client/module/components/image-transform"

const PropertyContactDetails = props => {
  const [modalSendfrndformOpen, setSendfrndformOpen] = React.useState(false)
  const openSendfrndformModal = () => {
    setSendfrndformOpen(true)
  }
  const closeSendfrndformModal = () => {
    setSendfrndformOpen(false)
  }

  const {
    loading: loading,
    error: error,
    data: data,
  } = PeopleEmail(props?.crm_negotiator_id?.email)

  const negoData = data?.teams[0]

  let processedImages = JSON.stringify({})
  if (negoData?.imagetransforms?.Tile_image_Transforms) {
    processedImages = negoData.imagetransforms.Tile_image_Transforms
  }

  let negName = props.crm_negotiator_id?.name
  let negNumber = props.crm_negotiator_id?.phone
  if(props?.__typename == "Offplan"){
    negName = props.crm_negotiator_id?.name + " " + props.crm_negotiator_id?.secondName;
    negNumber = props.crm_negotiator_id?.mobile
  }

  return (
    <>
      <div className="card-wrap">
        <h2>Contact Agent</h2>
        <div className="content-wrapp">
          {negoData?.image ? (
            <ImageTransform
              imagesources={negoData?.image?.url}
              renderer="srcSet"
              imagename="teams.Tile_image.nego"
              attr={{
                alt: `${negoData?.image?.alternativeText} - Arabian Estates`,
                class: "",
              }}
              imagetransformresult={processedImages}
              id={negoData?.id}
              format="source"
            />
          ) : (
            <img src={teamstatic} alt="content-img" />
          )}

          <div className="tele-wrap">
            {negoData&&
            <span className="contact-heading">
              {negName}
            </span>
            }

            <a className="phone" href={`tel:${negoData ? negNumber : "+971 4 324 3137"}`}>
              {/* {props.crm_negotiator_id?.phone} */}
              {negoData ? negNumber : "+971 4 324 3137"}
            </a>
          </div>
        </div>
        <div className="btn-wrap top-20">
          {/* <h4>{contactData.btnHead}</h4> */}
          <a
            href="javascript:void(0)"
            className="request-view d-xl-block d-none"
            onClick={openSendfrndformModal}
          >
            Book a Viewing
          </a>
          <Link to={ListPropertyBaseURL} className="request-callback">
            List Your Property
          </Link>
        </div>
      </div>
      <ModalTiny
        show={modalSendfrndformOpen}
        onHide={closeSendfrndformModal}
        className="book-a-viewing-modal modal-main-form modal"
      >
        <i className="icon-close" onClick={() => closeSendfrndformModal()}></i>

        <ModalTiny.Body className="people-details-form-modal event-section">
          <h2>Book a Viewing</h2>
          <p>
            For more information, please leave a few details below and a member
            of our team will be in contact soon.
          </p>
          <BookViewForm page_url={props.pageurl} property_title={props.property_title} property_img={props.property_img} />
        </ModalTiny.Body>
      </ModalTiny>
    </>
  )
}

export default PropertyContactDetails
